var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.demoMode)?_c('div',{staticClass:"bpjs-demo-banner",attrs:{"role":"status"}},[_c('i',{staticClass:"fas fa-flask",attrs:{"aria-hidden":"true"}}),_vm._m(0)]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v("Mode Demo BPJS")]),_c('span',[_vm._v("Data pada halaman ini adalah simulasi lokal dan tidak dikirim ke BPJS Kesehatan.")])])
}]

export { render, staticRenderFns }